<template>
  <Navbar />
  <HeroSection/>
  <Banner />
  <!-- <Referances /> -->
  <Footer />
</template>

<script setup>
import { useHead } from '@vueuse/head';
import Navbar from "@/components/Navbar-2.vue";
import HeroSection from "@/components/HeroSection.vue";
import Footer from "@/components/Footer.vue";
import Referances from "@/components/Referances.vue";
import Banner from "@/components/Banner.vue";

useHead({
  title: 'İntek Electronics - Otomasyon Sistemleri & Kart Tasarımı',
  meta: [
    {
      name: 'description',
      content: 'İntek Electronics olarak Gebze, Tuzla ve çevresinde endüstriyel otomasyon sistemleri, elektronik kontrol kartları ve sensör üretimi sunuyoruz.',
    },
    {
      name: 'keywords',
      content: 'İntek Electronics, otomasyon, elektronik kart, kontrol kartı, Gebze, Tuzla, sensör üretimi, Kocaeli',
    },
    {
      property: 'og:title',
      content: 'İntek Electronics - Güçlü Kontrol, Akıllı Çözümler',
    },
    {
      property: 'og:description',
      content: 'Araştırıyoruz, geliştiriyoruz, üretiyoruz. Endüstriyel otomasyonun güvenilir çözüm ortağı.',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:url',
      content: 'https://www.intekelectronic.com.tr/',
    },
    {
      property: 'og:image',
      content: 'https://www.intekelectronic.com.tr/images/banner-og.jpg',
    }
  ]
});
</script>